




















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { SparqlVariable } from '../model/models'
import sparqlService from '../service/SparqlService'
// import { MathJax } from 'MathJax'
import main from '../main'

@Component({
  components: { },
  computed: mapGetters([
    'concept',
    'ontology',
    'language'
  ])
})
export default class ConceptPane extends Vue {
  downloadUrl:string = ''
  fieldsLiterals = [
    {
      label: 'Property',
      key: 'property'
    },
    {
      label: 'Value',
      key: 'value'
    },
    {
      label: 'Language',
      key: 'language'
    }]
  fieldsProperty = [
    {
      label: 'Property',
      key: 'predicate'
    },
    {
      label: 'Value',
      key: 'object'
    }]
  fieldsIncoming = [
    {
      label: 'Related concept',
      key: 'subject'
    },
    {
      label: 'Property',
      key: 'predicate'
    },
    {
      label: 'Concept',
      key: 'object'
    }]
  fieldsOblank = [
    {
      label: ' ',
      key: 'object'
    }]
  fieldsInstances = [
    {
      label: 'Instance',
      key: 'subject'
    }]

  mounted () {
    this.$nextTick(function () {
      // MathJax.Hub.Config({tex2jax: {inlineMath: [['$','$'], ['\\(','\\)']]}});
      var ontology = this.$route.params.ontology
      var concept = this.$route.params.concept
      console.log('ConceptPane: mounted hook. ontology from router:', ontology, ' concept:', concept)

      this.downloadUrl = sparqlService.serverUrl + '/data/' + ontology + '/'

      var currentOntology = main.store.getters.ontology

      if (currentOntology.id !== ontology) {
        console.log('Ontology not yet loaded. Get from server')
        sparqlService.getOntologyAsync(ontology)
      }
    })
  }

  getLabelOrId (spo:SparqlVariable) {
    if (spo.label) {
      return spo.label
    }
    return spo.prefixId
  }
  extractConceptFromId (id:string):string {
    if (id && id !== '') {
      return sparqlService.extractConceptFromId(id)
    } else {
      return id
    }
  }

  onClicked ($event:any, spo:SparqlVariable) {
    sparqlService.gotoConcept(this.$router, spo.id)
  }
  @Watch('ontology')
  watchOntology () {
    var onto = main.store.getters.ontology
    console.log('ontology changed:', onto.id)
    if (main.store.getters.externalRequest) {
      var conceptId = onto.server +
               '/' + this.$route.params.type +
               '/' + this.$route.params.ontology +
               '/' + this.$route.params.concept
      console.log('External Request. Assembling the ID of the concept:', conceptId)
      sparqlService.getConceptAsync(onto.id, conceptId)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConceptPane.vue